// Axios
import Axios from "./axios"

export const sendResetPassword = (values) => {
    return new Promise((resolve, reject) => {
        const data = Axios.post(`/user/resetPassword`, values)
        setTimeout(() => resolve(data), 0)
    })
}